import { render, staticRenderFns } from "./AssetServiceDialog.vue?vue&type=template&id=a2cc480a&scoped=true&"
import script from "./AssetServiceDialog.vue?vue&type=script&lang=js&"
export * from "./AssetServiceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cc480a",
  null
  
)

export default component.exports